const bitOperations = require('./bitOperations');
const ascii = require('./ascii');

const compactMethod = {
  /// Decimal
  INTEGER: '001',
  /// Hexadecimal
  HEXADECIMAL: '010',
  /// 5 bit code (Upercase Alphabetic) A-Z, 1-7
  CAPITALALPHABET5BIT: '011',
  /// 6 bit code (uppercase Alphabetic, numberic, etc) A-Z, a-z, 0-9, +, /
  ALPHANUMERIC6BIT: '100',
  /// 7 bit code (ISO 646) Ascii 67
  ASCII67: '101',
  /// Octet (SST-"ASCII")
  EXTENDEDASCII: '110',
  /// variable length UTF-8?
  UTF8: '111', //not supported at this time
};
Object.freeze(compactMethod);

function parseNext(inputInHex) {
  let wasUtf8 = false;
  try {
    let precursorLength = 2;
    let precursor = bitOperations.hexStringToBitString(inputInHex.substring(0, precursorLength));
    const offset = precursor.substring(0, 1); //eslint-disable-line
    const compactCode = precursor.substring(1, 1 + 3);
    let objectIdBits = precursor.substring(4);
    let objectId = parseInt(bitOperations.bitStringToDecString(objectIdBits));
    if (objectIdBits === '1111') {
      precursorLength = 3;
      precursor = bitOperations.hexStringToBitString(inputInHex.substring(0, precursorLength));
      objectIdBits = precursor.substring(4);
      objectId = parseInt(bitOperations.bitStringToDecString(objectIdBits)) + 15;
    }
    const dl = inputInHex.substring(precursorLength, precursorLength + 2);
    let dataLength = parseInt(dl); //length in words, 2 hex per word
    if (dataLength === 'NaN') {
      return 'x';
    }
    dataLength = 2 * dataLength; //length in hex characters
    const data = inputInHex.substring(precursorLength + 2, precursorLength + 2 + dataLength);
    const remainder = inputInHex.substring(precursorLength + 2 + dataLength);
    let value = '';
    switch (compactCode) {
      case compactMethod.INTEGER:
        value = bitOperations.bitStringToDecString(bitOperations.hexStringToBitString(data));
        break;
      case compactMethod.HEXADECIMAL:
        value = data;
        break;
      case compactMethod.CAPITALALPHABET5BIT:
        value = bitOperations.bitStringTo5bitAlphabetString(bitOperations.hexStringToBitString(data));
        break;
      case compactMethod.ALPHANUMERIC6BIT:
        value = bitOperations.bitStringTo6bitAlphaNumericString(bitOperations.hexStringToBitString(data));
        break;
      case compactMethod.ASCII67:
        value = bitOperations.bitStringTo7bitAscii67String(bitOperations.hexStringToBitString(data));
        break;
      case compactMethod.EXTENDEDASCII:
        value = ascii.fromHex(data);
        break;
      case compactMethod.UTF8:
        wasUtf8 = true;
        throw new Error('UTF8 encoding is not supported at this time');
      default:
        return 'null';
    }

    return {
      value,
      remainder,
      objectId,
      compactCode,
    };
  } catch (error) {
    if (wasUtf8) throw error;
    return error;
  }
}

module.exports = {
  compactMethod,
  parseNext,
};
